<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div
      id="addgroupdevice"
      class="modal fade"
      :class="{ show: show }"
      style="background: rgba(0,0,0,0.5)"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" v-click-outside="onCancel" id="modal">
          <div class="card-body">
            <h5 class="mx-0 px-2">
              {{ $t("add_dev") }}
            </h5>
            <div
              v-if="mssg"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <form class="p-2" @submit.prevent="adddevices">
              <ComboBox
                :data="sorteddevices"
                :isItemChecked="(device) => selecteddevices.includes(device.id)"
                @checkClick="(device) => updateDevice(device)"
                @doSearch="doSearch"
                :isSelectAll="
                  selecteddevices.length === allSortedDevices.length
                "
                :selectAll="
                  () => (selecteddevices = allSortedDevices.map(({ id }) => id))
                "
                :deSelectAll="() => (selecteddevices = [])"
                :label="$t('devices')"
              />
              <div
                class="form-group"
                style="display:flex; justify-content: space-between"
              >
                <button
                  @click="onCancel"
                  type="button"
                  class="btn btn-secondary"
                >
                  {{ $t("cancel") }}
                </button>
                <button type="submit" class="btn btn-primary">
                  {{ $t("save") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
// import CongratulationsModal from "./CongratulationsModal";
import ComboBox from "../../components/ComboBox.vue";

export default {
  name: "AddGroupDevice",
  props: {
    show: Boolean,
  },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      sorteddevices: [],
      allSortedDevices: [],
      selecteddevices: [],
      selecteddevicesArr: [],
      dropdownShow: false,
      mssg: "",
      Errormssg: "",
      searchQuery: "",

      // congratulationsModal: true,
    };
  },
  mounted() {
    this.fetchallDevices().then(() => {
      this.sorteddevices = this.devices
        .filter(
          (device) =>
            !this.singlegroup.devices.some(
              (groupDevice) => groupDevice.id === device.id
            )
        )
        // .filter((device) => !device.group)
        .map(({ settings, ...rest }) => ({
          name: settings.name,
          settings,
          ...rest,
        }));
      this.allSortedDevices = this.sorteddevices;
      this.isLoading = false;
    });
  },
  components: {
    Loading,
    ComboBox,
    // CongratulationsModal,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters(["devices", "singlegroup"]),
  },
  methods: {
    ...mapActions(["fetchallDevices", "addGroupDevices", "fetchSingleGroup"]),
    onCancel() {
      this.selecteddevices = [];
      this.selecteddevicesArr = [];
      this.$emit("closeAddGroupDevice");
    },
    closeDropdown() {
      if (this.dropdownShow == true) {
        this.dropdownShow = false;
      }
    },
    adddevices() {
      this.Errormssg = "";
      // let devices = document.getElementsByClassName("checkbox");
      // let selecteddevices = [];
      // for (let i = 0; i < devices.length; i++) {
      //   if (devices[i].checked) {
      //     selecteddevices.push(
      //       ...this.devices.filter(
      //         (device) => device.deviceTag == devices[i].value
      //       )
      //     );
      //   }
      // }
      const newdevices = {
        devices: this.selecteddevices,
      };
      if (this.selecteddevices.length > 0) {
        this.isLoading = true;
        this.addGroupDevices({ devices: newdevices, id: this.$route.params.id })
          .then((res) => {
            this.fetchSingleGroup({ id: this.$route.params.id }).then(() => {
              this.onCancel();
            });
            this.isLoading = false;
            this.mssg = res.data.payload.message;
            setTimeout(() => {
              this.isLoading = true;
            }, 1000);
          })

          .catch((error) => {
            this.isLoading = false;
            this.Errormssg =
              error.response.data.message[0].toUpperCase() +
              error.response.data.message.slice(1);
            // error.response can be null
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      } else {
        this.Errormssg = "No device(s) selected";
      }
    },
    doSearch({ target: { value } }) {
      const filtered = this.allSortedDevices.filter(
        ({ settings: { name }, group }) =>
          name.toLowerCase().includes(value.toLowerCase()) && !group
      );
      this.sorteddevices = filtered;
    },
    updateDevice(val) {
      const index = this.selecteddevices.indexOf(val.id);
      if (index !== -1) {
        this.selecteddevices.splice(index, 1);
      } else this.selecteddevices = [...this.selecteddevices, val.id];
    },
  },
};
</script>

<style scoped>
.modal-content {
  overflow-y: inherit;
}
.modal-dialog {
  max-width: 500px !important;
}
.dropdown-toggle {
  border: 1px solid;
}
.device-dropdown {
  position: absolute;
  will-change: transform;
  top: 20px;
  left: -45%;
  transform: translate3d(313px, 35px, 0px);
  max-height: 200px;
  width: 15rem;
  overflow-y: auto;
}
.dropdown-button {
  border-radius: 2px;
}
</style>

<i18n>
{
	"en": {
		"add_dev": "Add Devices",
		"sel_dev": "Select Devices"
	},
	"fr": {
		"add_dev": "Ajouter des appareils",
		"sel_dev": "Choisir un appareil"
	},
	"sw": {
		"add_dev": "Ongeza Vifaa",
		"sel_dev": "Ongeza Vifaa"
	}
}
</i18n>
